import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: './send-mail-modal.component.html',
  styleUrls: ['./send-mail-modal.component.scss']
})
export class SendMailModalComponent implements AfterViewInit{
  public form: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });
  public disabled: boolean = true;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private _toaster: ToastrService,
    private _translation: TranslateService,
    private dialogRef: MatDialogRef<SendMailModalComponent>
  ) { }

  ngAfterViewInit(): void {
    document.getElementById('SendMailModal__input').focus();
  }
  onCheckInputEvent(event) {
    this.disabled = !this.form.valid;
    if (event.key === 'Enter' && !this.disabled) {
      document.getElementById('SendMailModal__submitButton').click();
    }
  }

  sendReportMail() {
    const email = this.form.get('email').value;
    const dataToSend = { email: email }; // Göndermek istediğiniz veriyi tanımlayın
    this.dialogRef.close(dataToSend);
    this._toaster.success(this._translation.instant('report_sent'));
  }

}
